import script from "./voiceEffect.vue?vue&type=script&lang=ts&setup=true"
export * from "./voiceEffect.vue?vue&type=script&lang=ts&setup=true"

import "./voiceEffect.vue?vue&type=style&index=0&id=89a383b2&lang=scss&scoped=true"
import "./voiceEffect.vue?vue&type=style&index=1&id=89a383b2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a383b2"]])

export default __exports__